/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApplicationByIdResponse } from '../models/ApplicationByIdResponse';
import type { ApproveApplicationPayload } from '../models/ApproveApplicationPayload';
import type { CompletedApplicationResponse } from '../models/CompletedApplicationResponse';
import type { PendingApplicationResponse } from '../models/PendingApplicationResponse';
import type { RejectApplicationPayload } from '../models/RejectApplicationPayload';
import type { RejectedApplicationResponse } from '../models/RejectedApplicationResponse';
import type { RetryPartnerApplicationFromLastErrorPayload } from '../models/RetryPartnerApplicationFromLastErrorPayload';
import type { SubmitApplicationFromCmsPayload } from '../models/SubmitApplicationFromCmsPayload';
import type { SubmitApplicationFromCmsResponse } from '../models/SubmitApplicationFromCmsResponse';
import type { SubmitApplicationPayload } from '../models/SubmitApplicationPayload';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PartnerOnboardingService {
    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiPartnerOnboardingSubmitApplication(
        requestBody?: SubmitApplicationPayload,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/partner-onboarding/submit-application',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns SubmitApplicationFromCmsResponse Success
     * @throws ApiError
     */
    public static postApiPartnerOnboardingSubmitApplicationFromCms(
        requestBody?: SubmitApplicationFromCmsPayload,
    ): CancelablePromise<SubmitApplicationFromCmsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/partner-onboarding/submit-application-from-cms',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiPartnerOnboardingApproveApplication(
        requestBody?: ApproveApplicationPayload,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/partner-onboarding/approve-application',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiPartnerOnboardingRejectApplication(
        requestBody?: RejectApplicationPayload,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/partner-onboarding/reject-application',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiPartnerOnboardingRetryPartnerApplicationFromLastError(
        requestBody?: RetryPartnerApplicationFromLastErrorPayload,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/partner-onboarding/retry-partner-application-from-last-error',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @returns CompletedApplicationResponse Success
     * @throws ApiError
     */
    public static getApiPartnerOnboardingCompletedApplications(): CancelablePromise<Array<CompletedApplicationResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/partner-onboarding/completed-applications',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @returns PendingApplicationResponse Success
     * @throws ApiError
     */
    public static getApiPartnerOnboardingPendingApplications(): CancelablePromise<Array<PendingApplicationResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/partner-onboarding/pending-applications',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @returns RejectedApplicationResponse Success
     * @throws ApiError
     */
    public static getApiPartnerOnboardingRejectedApplications(): CancelablePromise<Array<RejectedApplicationResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/partner-onboarding/rejected-applications',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param id
     * @returns ApplicationByIdResponse Success
     * @throws ApiError
     */
    public static getApiPartnerOnboardingApplication(
        id: string,
    ): CancelablePromise<ApplicationByIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/partner-onboarding/application/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Invalid access token`,
                404: `Not Found`,
            },
        });
    }
}
